import { useMemo } from 'react';

import compact from 'lodash/compact';
import uniq from 'lodash/uniq';

import type { ListClusterRestrictionsResponseResourceRestrictions } from '@cast/types';

import type { WorkloadData } from '../types';

type Props = {
  restrictions: ListClusterRestrictionsResponseResourceRestrictions[];
  resourceName?: string;
  resourceNamespace?: string;
  resourceKind?: string;
};

export const useWorkloadData = ({
  restrictions,
  resourceName,
  resourceNamespace,
  resourceKind,
}: Props): WorkloadData => {
  return useMemo(() => {
    const filtered = restrictions.filter(
      (r) =>
        r.resource?.resourceName === resourceName &&
        (!resourceNamespace ||
          r.resource?.resourceNamespace === resourceNamespace)
    );

    const restrictionIds = uniq(
      compact(filtered.flatMap((r) => r.restrictionIds))
    );

    const kind = resourceKind || filtered[0]?.resource?.resourceKind;

    return {
      resourceName: resourceName || '',
      resourceNamespace,
      resourceKind: kind,
      restrictionIds,
    };
  }, [restrictions, resourceName, resourceNamespace, resourceKind]);
};
